export default [
  {
  path: '/active-xkrank/index',
    name: 'index',
    component: () => import('@/views/active-xkrank/index'),
    meta: {
      title: ''
    }
  },  
]

